import { unref } from 'vue';
import { joinTeam } from '@/api/joinTeam';
import { setBlackListTeamErrorType } from '@/utils';
import { authCode } from '@/utils/authCode';

export async function useJoinTeam (trackCode: string) {
  const shareCode = unref(trackCode);
  setBlackListTeamErrorType('join');
  let  res = await joinTeam(shareCode);
  if (res.code === 15001) {
    const captchaData = await authCode();
    res = await joinTeam(shareCode, captchaData);
  }
  return res;
}
